export const state = {
  boundaries: { type: 'FeatureCollection', features: [] },
  currentBoundary: null,
  isLoading: false,
  hoveredBoundaryProjectId: null,
}
